angular.module('impactx.search').controller('SearchListContactCtrl', SearchListContactCtrl);
SearchListContactCtrl.$inject = [
    '$scope',
    'searchFilter',
    'SearchService',
    'AppConfiguration',
    'SearchFilter',
    'dataGen',
    'ToolbarService',
    'TranslationService',
    'BackService',
    '$routeParams'
];

function SearchListContactCtrl($scope, searchFilter, SearchService, AppConfiguration, SearchFilter, dataGen, ToolbarService,
                                  TranslationService, BackService, $routeParams) {
    var self = this;
    self.pageNumber = 1;
    ToolbarService.showSearchFilterToggle();
    self.resetPageNumber = {value: false};
    self.maxPageNumberContacts = 0;
    self.baseObject = $routeParams.objectName;
    $scope.timeId = 0;
    $scope.search = function (index, selectedSort) {
        if (!index) {
            self.resetPageNumber.value = true;
            self.pageNumber = 1;
        }
        else {
            self.pageNumber = index;
        }
        var filters = SearchFilter.getFilters();
        self.filter = filters;
        if (filters && filters.sort) {
            filters.sort.selected = selectedSort;
        }
        return dataGen.postAsForm($scope, {filters: filters, objectName: $routeParams.objectName, objectId: $routeParams.objectId,
            pageNumber: self.pageNumber}, "/search/contacts").then(function (result) {
            $scope.timeId = Date.now();
            self.initialized = true;
            $scope.data = result.data;
            $scope.trns = result.trns;
            self.maxPageNumberContacts = Math.floor($scope.data.searchResults.numOfContacts / 100) + 1;
            defineButtons();
        })
    };
    $scope.search();

    self.back = function () {
        BackService.back();
        self.filter.listFilters = SearchFilterStorage.getFreshFilter().listFilters;
    }

    function defineButtons() {
        var buttonDefinition = [
            {label: TranslationService.get("back"), action: self.back, type: 'dialogaction'}
        ];
        ToolbarService.hideBackButton();
        ToolbarService.setButtons(buttonDefinition);
    }
}
